<template>
    <v-container style="margin: 60px 10%">
      <vueHeadful
      :title="this.$i18n.t('Menu.Tours') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
          <v-col cols="12" align="center" style="margin-bottom: 5%">
              <h1 :style="responsiveTitulo" class="titulo">{{$t('Menu.Tours')}}</h1>
            </v-col>
            <v-col cols="12" xs="12" md="12">
              <v-img :src="tours.imagen" max-height="600px"></v-img>
            </v-col>
            <v-col cols="12" xs="12" md="12">
              <div v-if="getIdioma === 'es'" class="textoMagazine" v-html="tours.descripcionEs" />
              <div v-else class="textoMagazine" v-html="tours.descripcionEn" />
            </v-col>
          <v-form ref="form" v-model="valido">
            <v-col cols="12" style="padding: 60px 10%">
              <v-row>
                <v-col cols="12" align="center">
                  <h1>{{$t('Regalo.ReservaTour')}}</h1>
                </v-col>
                <v-col cols="12" xs="12" md="6" align="center">
                  <h2 class="pb-5">{{$t('Oficina.Fecha')}}</h2>
                  <v-date-picker v-if="$vuetify.breakpoint.name === 'xs'" style="width:auto!important;" event-color="primary" v-model="fecha" :rules="[v => !!v || $t('Regalo.FechaRequerido')]"></v-date-picker>
                  <v-date-picker v-else landscape event-color="primary" v-model="fecha" :rules="[v => !!v || $t('Regalo.FechaRequerido')]"></v-date-picker>
                </v-col>
                <v-col cols="12" xs="12" md="6" style="padding-top:60px">
                  <v-row>
                    <v-col cols="12">
                      <v-select solo :items="tours.pasajeros" item-text="cantidad" return-object v-model="precio" :label="$t('Regalo.NumeroPasajeros')" :rules="[v => !!v || $t('Regalo.PasajerosRequerido')]" />
                    </v-col>
                    <v-col cols="12">
                      <v-select solo :items="tours.preferencias" :item-text="getIdioma === 'es' ? 'tituloEs' : 'tituloEn'" v-model="preferencias" multiple label="Preferencias" :rules="[v => !!v || $t('Regalo.PreferenciasRequerido')]"/>
                    </v-col>
                    <v-col cols="12">
                      <v-select solo :items="tours.horarios" v-model="horario" :label="$t('Regalo.Horario')" :rules="[v => !!v || $t('Regalo.HorarioRequerido')]" />
                    </v-col>
                    <v-col cols="12" align="center">
                      <h3 v-if="precio && getMoneda === 'COP'">{{$t('Regalo.Cantidad')}}: {{Number(precio.precio).toLocaleString()}} {{getMoneda}}</h3>
                      <h3 v-if="precio && getMoneda === 'USD'">{{$t('Regalo.Cantidad')}}: {{Number(precio.precio/getDolar).toFixed().toLocaleString()}} {{getMoneda}}</h3>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" align="center" v-if="tours.activado">
                  <v-btn x-large style="min-width:20%!important" color="black white--text" @click="pagar()" :disabled="!valido">Pagar</v-btn>
                </v-col>
                <v-col cols="12" align="center" v-if="!tours.activado">
                  <h3>Los Tours Artísticos no están disponibles en este momento</h3>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-row>
        <v-row class="mt-5">
            <v-col cols="12" align="center">
                <h2 class="titulo mb-2 vietnam">{{$t('Formularios.Email')}}</h2>
                <h3 class="titulo font-weight-regular vietnam">soycliente@trartist.com</h3>
            </v-col>
            <v-col cols="12" align="center">
                <h2 class="titulo mb-2">{{$t('Formularios.TelefonoYWhatsapp')}}</h2>
                <h3 class="titulo font-weight-regular vietnam">+57 3213025754</h3>
            </v-col>
            <v-col cols="12" align="center" class="mt-2">
                <h2 class="titulo vietnam">Bogotá - Colombia</h2>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'Tours',
  data () {
    return {
      tours: [],
      precio: null,
      preferencias: null,
      horario: null,
      fecha: null,
      valido: false
    }
  },
  methods: {
    ...mapActions(['anadirCarrito']),
    pagar () {
      var producto = {
        tipo: 'tour',
        producto: {
          titulo: 'Tour',
          imagenPrincipal: this.tours.imagen,
          cantidad: 1,
          pasajeros: this.precio.cantidad,
          precio: this.precio.precio,
          preferencias: this.preferencias,
          fecha: this.fecha,
          horario: this.horario,
          tipo: 'tour'
        }
      }
      this.anadirCarrito(producto)
    }
  },
  mounted () {
    firebase.firestore().collection('utilidades').doc('tours').get().then(info => {
      this.tours = info.data()
    })
  },
  computed: {
    ...mapGetters(['getIdioma', 'getMoneda', 'getDolar']),
    responsiveTitulo () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'font-size:2rem;line-height:2rem;'
        case 'sm': return 'font-size:3rem;line-height:3rem;'
        case 'md': return 'font-size:3rem;line-height:3rem;'
        case 'lg': return 'font-size:4rem;line-height:4rem;'
        case 'xl': return 'font-size:4rem;line-height:4rem;'
        default: return 'font-size:4rem;line-height:4rem;'
      }
    }
  }
}
</script>
<style>
.theme--light.v-picker__body {
  width: auto!important;
}
</style>
